/**
 * This file contains some syntactic-sugar wrappers for making HeadlingLevelBoundary
 * easier to work with.
 */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { forwardRef } from 'react';
import HeadingLevelBoundary from './HeadingLevelBoundary';
/**
 * Render a `section` tag and handle updating the heading level context
 */ const Section = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ React.createElement(HeadingLevelBoundary, _object_spread_props(_object_spread({
        tag: "section"
    }, props), {
        ref: ref
    })));
Section.displayName = 'Section';
/**
 * Render a `main` tag and handle updating the heading level context
 */ const Main = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ React.createElement(HeadingLevelBoundary, _object_spread_props(_object_spread({
        tag: "main"
    }, props), {
        ref: ref
    })));
Main.displayName = 'Main';
/**
 * Render a `nav` tag and handle updating the heading level context
 */ const Nav = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ React.createElement(HeadingLevelBoundary, _object_spread_props(_object_spread({
        tag: "nav"
    }, props), {
        ref: ref
    })));
Nav.displayName = 'Nav';
/**
 * Render an `aside` tag and handle updating the heading level context
 */ const Aside = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ React.createElement(HeadingLevelBoundary, _object_spread_props(_object_spread({
        tag: "aside"
    }, props), {
        ref: ref
    })));
Aside.displayName = 'Aside';
export { Section, Main, Nav, Aside };
